import { Navigate, Outlet } from "react-router-dom";
import { Unauthorized } from "../../core/components/Unauthorized";
import { useModules } from "../../core/hooks/useModules";
import { useLastPath } from "../../core/hooks/useLastPath";
import { useSlugs } from "../../core/hooks/useSlugs";
import { Module } from "../../ui/components/Module";

export const ModulePicker = () => {
  const lastPath = useLastPath();
  const {locationSlug} = useSlugs();
  const modules = useModules();

  if (!modules.length) {
    return (
      <Module>
        <Unauthorized/>
      </Module>
    );
  }

  if (lastPath === locationSlug) {
    return <Navigate to={`${modules[0].path}`} replace={true}/>;
  }

  return <Outlet/>;
};
